import script from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=549015ae&lang=css"

const __exports__ = script;

export default __exports__